<mat-button-toggle-group
    [value]="value()"
    (change)="handleValueChange($event)"
    [multiple]="multiple()"
    [disabled]="disabled()"
    [vertical]="vertical()"
    [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
    [hideMultipleSelectionIndicator]="hideMultipleSelectionIndicator()"
    [ngClass]="groupClass()">
    @for(option of options(); track option.value) {
        <mat-button-toggle
            [value]="option.value"
            [disabled]="option.disabled"
            [matTooltip]="option.tooltip || ''"
            [matTooltipDisabled]="!option.tooltip"
            [ngClass]="buttonClass()"
            aria-label="{{option.label || option.value}}">

            @if(option.icon) {
                <mat-icon 
                    fontSet="material-icons-outlined" 
                    [ngClass]="option.iconClass || iconClass()"
                    class="toggle-icon">
                    {{ option.icon }}
                </mat-icon>
            }
            
            @if(option.label) {
                <span class="toggle-label">{{ option.label }}</span>
            }
        </mat-button-toggle>
    }
</mat-button-toggle-group>